module.exports = __webpack_public_path__ + "media/right.6bc0934a.mp3";